import { render, staticRenderFns } from "./Repository.vue?vue&type=template&id=74d37fcb&scoped=true&"
import script from "./Repository.vue?vue&type=script&lang=js&"
export * from "./Repository.vue?vue&type=script&lang=js&"
import style0 from "./Repository.vue?vue&type=style&index=0&id=74d37fcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d37fcb",
  null
  
)

export default component.exports